import CityPage from '../../components/CityPage';

const cityData = {
    name: "Dives-sur-Mer",
    slug: "dives-sur-mer",
    postalCode: "14160",
    intro: "CC Débarras 14 propose un service de débarras professionnel à Dives-sur-Mer. Maisons, appartements, caves, garages : nous intervenons pour tous types de biens sur la commune. Que ce soit dans le cadre d'une succession, d'un départ en maison de retraite, d'une vente ou d'un simple rangement, notre équipe prend en charge le tri, l'enlèvement et l'évacuation de vos affaires avec soin et efficacité.",
    nearby: ["Houlgate", "Cabourg", "Villers-sur-Mer", "Auberville"],
};

const DivesSurMer = () => <CityPage city={cityData} />;

export default DivesSurMer;
